export const alloysPartnersShopifyFetchCollections = "/alloys/partners/shopify/:integration_id/fetch_collections";
